HomepageCarousel = require '../../carousel/frontend/carousel'

performSearch = (params = {}) ->
  @xhr?.abort()

  @xhr = $.ajax
    url: '/goods/deals/megamindhome'
    data: params

  search = _.clone Backbone.Events

  @xhr.done _(search.trigger).bind search, 'success'
  @xhr.fail (xhr, textStatus) =>
    if not textStatus == "abort"
      _(search.trigger).bind search, 'error'
    #search.trigger 'error' unless textStatus == "abort"
    #location.href = "/goods?category=all"
  @xhr.always ->
    search.trigger 'complete', arguments...
    search.off()

  { on: _(search.once).bind(search) }

module.exports = class DealsMmSearch
  constructor: (options={}) ->
    @_events = _.extend {}, Backbone.Events
    {@inNewHomepage, @carouselConfig, @homeWidgetPreview, @showFreeShippingModal} = options

    {datetime, megamindPreview} = @homeWidgetPreview if @homeWidgetPreview
    if datetime and megamindPreview
      @params = {datetime, megamindPreview}

    dealsSearch = performSearch(@params)
    dealsSearch.on 'error', @_triggerErrorHandler
    dealsSearch.on 'success', @_triggerSuccessHandler
    null

  on: (event, callback) ->
    @_events.on event, callback

  _triggerErrorHandler: =>
    @_events.trigger 'error'
    @_events.stopListening()

  _triggerSuccessHandler: ({deals, dealIdList}={}, textStatus) =>
    if textStatus != 'success'
      @_triggerErrorHandler()
    else
      @_events.trigger 'success', deals, dealIdList
      Groupon.Utils.lazyLoadImages()
      if @inNewHomepage
        new HomepageCarousel({@carouselConfig, @showFreeShippingModal, @inGoodsHomepageSSR})
      @_events.stopListening()
